import type { SseEvent, SseSource } from "./types";

const KNOWN_EVENT_TYPES = [
    "session.started",
    "session.ended",
    "session.extended",
    "queue.entry.added",
    "queue.entry.invited",
    "queue.entry.passed",
    "queue.entry.cancelled",
    "queue.entry.expired",
    "queue.entry.served",
    "court.status_changed",
    "tenant.settings_changed",
    "system.lagged",
    "system.replay_truncated",
    "system.token_revoked",
];

export function publicSource(url: string): SseSource {
    const es = new EventSource(url);
    let eventCb: ((e: SseEvent) => void) | null = null;
    let errorCb: ((err: unknown) => void) | null = null;

    es.addEventListener("error", (e) => errorCb?.(e));

    for (const t of KNOWN_EVENT_TYPES) {
        es.addEventListener(t, (ev: Event) => {
            const msgEv = ev as MessageEvent;
            eventCb?.({
                id: msgEv.lastEventId,
                event_type: t,
                payload: msgEv.data ? JSON.parse(msgEv.data) : null,
            });
        });
    }

    return {
        onEvent(h) {
            eventCb = h;
        },
        onError(h) {
            errorCb = h;
        },
        close() {
            es.close();
        },
    };
}
